import { Environment } from "./env";

export const ProdEnvironment: Environment = {
  base_url: "https://aaneelconnect-api-sandbox.aaneelconnect.com", 
  send_email_url: "https://communication.aaneelcare.com/messagingservice/api",
  send_onyx_email_url:"https://communication.aaneelcare.com/communicationservice/api"
};